

import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS'
import ListDropItems from '../../DragAndDropList/presents/ListDropItems'
import NewspaperDropSwitch from '../present/NewspaperDropSwitch'
import { updateNewspaperOrder } from '../../../actions'
import ListDropConditionalWrapper from '../../DragAndDropList/presents/ListDropConditionalWrapper'
import Translation from '../../Translation/cont/Translation'

const mapDispatchToProps = (dispatch, ownProps) => ({
    reorderNewspaperItems: (dragIndex, hoverIndex) => {
        const dataType = ownProps.dataType
        const order = ownProps.newspaperData[dataType].order
        const movedElement = order.splice(dragIndex, 1)[0];
        order.splice(hoverIndex, 0, movedElement);
        dispatch(updateNewspaperOrder(order, dataType))
    }
})

const NewspaperDropzoneContainer = ({
    labelTransId,
    newspaperData,
    dndType,
    dataType,
    canDropTypes,
    displayDropzones,
    basicUrl,
    addNewspaperItem,
    deleteNewspaperItem,
    reorderNewspaperItems, 
}) => {
    let listId
    let canDrop = true
    const itemData = newspaperData[dataType]
    const canDropCallback = canDropTypes => (props, sourceObj) => canDrop && canDropTypes.includes(sourceObj.type)

    listId = 'newspaper_' + dataType

    return (
        <ListDropItems
            listId={listId}
            title ={labelTransId ? <Translation id={labelTransId} /> : false}
            order={itemData.order}
            items={itemData.items}
            dataType={dataType}

            dndType={dndType}
            displayDropzones={displayDropzones}
            ChildSwitchItem={NewspaperDropSwitch}
            conditionalWrapper={ListDropConditionalWrapper}
            params={false}
            basicUrl={basicUrl}

            canDropCallback={canDropTypes ? canDropCallback(canDropTypes) : null}

            canEdit={true}
            canDelete={true}
            
            addItem={(listId, itemId, itemType) => canDrop && (!canDropTypes || canDropTypes.includes(itemType)) && addNewspaperItem(itemId, itemType, listId)}
            reorderItem={reorderNewspaperItems}
            deleteItem={(itemType, itemId) => deleteNewspaperItem(itemId, itemType)}

        />
    )
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(NewspaperDropzoneContainer) 